
export const formatIdCard = (number) => {
    const formatted = number.replace(/(\d)(\d{4})(\d{5})(\d{2})(\d)/, '$1-$2-$3-$4-$5');
    return formatted;
};

export const requestIdCard = (number) => {
    const formatted = number.replace(/-/g, '');
    // console.log(formatted);
    return formatted;
};


export const formatBankAccountNo = (bankAccountNo, isVisible = false) => {
    let newBankAccountNo = requestBankAccountNo(bankAccountNo);
    if (isVisible) {
        const firstPart = newBankAccountNo.slice(0, 3);
        const secondPart = newBankAccountNo.slice(3, 6);
        const remaining = newBankAccountNo.slice(6);
        let formattedNumber = `${firstPart}-${secondPart}-${remaining}`;
        newBankAccountNo = formattedNumber;
    } else {
        const maskStartLength = 6;
        const maskEndLength = 4;
        let formattedNumber = "xxx-xxx-";
        formattedNumber += newBankAccountNo.slice(maskStartLength, newBankAccountNo.length - maskEndLength);
        formattedNumber += "xxxx";
        return formattedNumber;
    }

    return newBankAccountNo;
}
export const formatPromptpayNo = (bankAccountNo, isVisible = false) => {
    let newBankAccountNo = requestBankAccountNo(bankAccountNo);
    if (isVisible) {
        newBankAccountNo = bankAccountNo;
    } else {
        const maskStartLength = 6;
        const maskEndLength = 4;
        let formattedNumber = "";
        formattedNumber += newBankAccountNo.slice(0, newBankAccountNo.length - maskEndLength);
        formattedNumber += "xxxx";
        return formattedNumber;
    }

    return newBankAccountNo;
}




export const requestBankAccountNo = (bankAccountNo) => {
    const formatted = bankAccountNo.replace(/-/g, '');
    // console.log(formatted);
    return formatted;
}

export const requestRemoveDat = (value) => {
    const formatted = value.replace(/-/g, '');
    return formatted;
}

export const formatTelephoneNumber = (input) => {
    let onlyDigits = input.replace(/\D/g, '');

    onlyDigits = onlyDigits.substring(0, 9);

    let formattedNumber = '';
    for (let i = 0; i < onlyDigits.length; i++) {
        if (i === 2 || i === 5) {
            formattedNumber += '-';
        }
        formattedNumber += onlyDigits[i];
    }

    return formattedNumber;
};

export const formatPhoneNumber = (input) => {
    let onlyDigits = input.replace(/\D/g, '');
    onlyDigits = onlyDigits.substring(0, 10);

    let formattedNumber = '';
    for (let i = 0; i < onlyDigits.length; i++) {
        if (i === 3 || i === 6) {
            formattedNumber += '-';
        }
        formattedNumber += onlyDigits[i];
    }

    return formattedNumber;
};

